<template>
  <div>
    <PageTitle>Пользовательское соглашение</PageTitle>
    <div class="mb-6 d-flex justify-space-between text-body-2 text-ui-kit-text-secondary">
      <div>г. Минск</div>
      <div>«14» апреля 2026 г.</div>
    </div>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      Настоящее Пользовательское соглашение (далее – ПС) регламентирует отношения между
      филиалом общества с ограниченной ответственностью «МЕДРОКЕТ» в Республике
      Беларусь, являющимся владельцем группы тематических сайтов «МедТочка», «Ydoc»,
      «МедОтвет», «МедЛок», «МедТочка для врача», «МедФлекс» и «МЕДРОКЕТ», а также
      программы для ЭВМ «Личный кабинет пациента МедТочка» для мобильных устройств
      (далее - «Приложение»), и любым лицом (далее - Пользователь), намеревающимся
      использовать и/или использующим Сайт и/или Приложение и вступает в силу с момента
      получения Пользователем доступа к Приложению и/или любой странице Сайта.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text font-weight-bold">
      В случае несогласия Пользователя хотя бы с одним из пунктов настоящего ПС или его
      неотъемлемых частей , Пользователь не имеет права продолжать использование Сайта
      и/или Приложения.
    </p>
    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      Термины и определения
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1. Сайт - информация, размещенная в информационно-телекоммуникационной сети Интернет
      по определенным сетевым адресам, в совокупности с комплексом исключительных прав (на
      доменные имена, базы данных и программы для электронных вычислительных машин),
      осуществление которых обеспечивает доступ к такой информации. В целях настоящего ПС
      под Сайтом, используемым в тексте данного ПС, понимаются сайты, расположенные в сети
      Интернет по адресам: https://medtochka.by, https://ydoc.by, а также сайты функционал,
      которых интегрируется с вышеуказанным сайтом, расположенные по адресам:
      https://medotvet.me, https://medlock.by, https://medrocket.me, https://doctor.medtochka.by,
      https://medflex.by.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      2. Пользователь - любой посетитель Сайта и/или Приложения, независимо от наличия у него
      регистрации на Сайте и/или в Приложении.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3. Администрация - коллектив пользователей Сайта и Приложения, уполномоченных проводить
      мероприятия по обеспечению функционирования Сайта и/или Приложения, а также
      мероприятия по обеспечению выполнения Пользователями условий ПС.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      4. Администратор - пользователь Сайта и/или Приложения, имеющий полный набор прав для
      управления Сайтом и/или Приложением и являющийся сотрудником Администрации.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      5. Регистрация – процедура, в ходе которой Пользователь предоставляет достоверные данные о
      себе по утвержденной форме регистрации.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      6. Материалы — любая информация (данные), указанная Пользователем при размещении на
      Сайте и/или в Приложении, а также загружаемая Пользователем на Сайт и/или в
      Приложение.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      7. Персональные данные — данные, указанные Пользователем при прохождении процедуры
      Регистрации, а также загружаемые Пользователем на Сайт и/или в Приложение сведения оПользователе
      и/или о третьих лицах. Данные хранятся в базе данных Сайта и/или
      Приложения и подлежат использованию исключительно в соответствии с действующим
      законодательством.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      8. Приложение — программа для ЭВМ «Личный кабинет пациента МедТочка» для мобильных
      устройств, доступная Пользователям для скачивания в магазине приложений для мобильных
      устройств.
    </p>
    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      Общие условия
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1. Использование
      материалов и сервисов Сайта и/или Приложения регулируется нормами
      действующего законодательства Республики Беларусь.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      2. Настоящее Соглашение является публичной офертой. Получая доступ к материалам Сайта
      и/или Приложения Пользователь считается присоединившимся к настоящему ПС.
    </p>
    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      Предмет Пользовательского соглашения
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      Филиал общества с ограниченной ответственностью «МЕДРОКЕТ» в Республике Беларусь
      предоставляет Пользователю возможность получать (загружать, скачивать, просматривать)
      материалы с Сайта и/или Приложения на условиях, являющихся предметом настоящего ПС.
      Администрация вправе в любое время в одностороннем порядке изменять условия
      настоящего ПС без какого-либо специального уведомления. Такие изменения вступают в
      силу с момента размещения новой версии ПС на Сайте и/или в Приложении. При несогласии
      Пользователя с внесенными изменениями он обязан немедленно отказаться от доступа к
      Сайту и/или Приложению, а равно прекратить использование любых материалов и сервисов
      Сайта и/или Приложения.
    </p>
    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      Описание услуг
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      Сайт и/или Приложение предлагает Пользователям доступ к широкому спектру сервисов. Все
      существующие на данный момент сервисы, а также любое их обновление, развитие,
      добавление новых сервисов является предметом настоящего ПС. Пользователь понимает и
      соглашается с тем, что все Сервисы предоставляются в том состоянии, в каком они находятся
      на момент отображения. Филиал общества с ограниченной ответственностью «МЕДРОКЕТ»
      в Республике Беларусь не несет ответственности ни за какие задержки, сбои, неверную или
      несвоевременную доставку, удаление или не сохранность какой-либо пользовательской
      персональной информации. Правообладателем Сайта и Приложения в целом, является
      Администрация, правообладателями отдельных сервисов Сайта и/или Приложения могут
      являться третьи лица, предоставившие Администрации право использовать соответствующие
      компоненты в составе сервиса Сайта и/или Приложения.
    </p>
    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      Обязательства Пользователя по Регистрации
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      Для того, чтобы воспользоваться некоторыми Сервисами Сайта и/или Приложения,
      Пользователю необходимо зарегистрироваться. Осуществляя регистрацию, Пользователь соглашается предоставить
      достоверную, правдивую, точную и полную информацию о себе
      по вопросам, предлагаемым в Форме Регистрации, и поддерживать эту информацию в
      актуальном состоянии. Если Пользователь предоставляет недостоверную, неверную
      информацию, Администрация имеет право приостановить либо отменить регистрацию
      Пользователя и отказать ему в использовании сервисов Сайта и/или Приложения.
    </p>
    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      Обязательства Пользователя по использованию сервисов Сайта и/или Приложения
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1. Используя Сайт и/или Приложение, Пользователь обязуется не совершать следующих
      действий:
    </p>
    <ul class="pl-6 custom-list">
      <li>
        <p class="text-body-2 mb-0 text-ui-kit-text">
          Любым способом посредством Сайта и/или Приложения размещать, распространять,
          сохранять, загружать и/или уничтожать материалы (информацию) в нарушение
          законодательства Республики Беларусь и международного законодательства.
        </p>
      </li>
      <li>
        <p class="text-body-2 mb-0 text-ui-kit-text">
          Размещать и/или передавать посредством Сайта и/или Приложения информацию в виде
          текста, изображения, видео, звука или программного кода, которая может быть
          противозаконной, угрожающей, оскорбительной, клеветнической, заведомо ложной, грубой,
          непристойной, вредить другим посетителям Сайта и/или Приложения, нарушать их права.
        </p>
      </li>
      <li>
        <p class="text-body-2 mb-0 text-ui-kit-text">
          Представляться чужим именем или от чужого имени, другого Пользователя Сайта и/или
          Приложения, сотрудника Администрации, а также вводить в заблуждение Пользователей
          и/или Администрацию относительно своей идентификации любым иным способом.
        </p>
      </li>
      <li>
        <p class="text-body-2 mb-0 text-ui-kit-text">
          Размещать, загружать заведомо недостоверную информацию.
        </p>
      </li>
      <li>
        <p class="text-body-2 mb-4 text-ui-kit-text">
          Размещать, загружать и/или передавать, используя Сайт и/или Приложение, информацию
          (материалы, файлы, скан-копии документов и иное) в случае, если Пользователь не имеет на
          это необходимого объема прав.
        </p>
      </li>
      <li>
        <p class="text-body-2 mb-4 text-ui-kit-text">
          Уничтожать и/или изменять любые материалы на Сайте и/или в Приложении, автором или
          правообладателем которых Пользователь не является.
        </p>
      </li>
      <li>
        <p class="text-body-2 mb-4 text-ui-kit-text">
          Использовать информацию Пользователей Сайта и/или Приложения, которая стала
          доступной в процессе использования Сайта и/или Приложения, в целях несоответствующих
          тематике Сайта и/или Приложения, а равно осуществление неправомерного сбора
          персональных данных Пользователей с целью их последующей обработки, то есть
          совершения действий (операций) с персональными данными, включая их сбор,
          систематизацию, накопление, распространение и уничтожение.
        </p>
      </li>
      <li>
        <p class="text-body-2 mb-4 text-ui-kit-text">
          Использовать информацию о телефонах, почтовых адресах, адресах электронной почты для
          целей иных, нежели тематика Сайта и/или Приложения.
        </p>
      </li>
      <li>
        <p class="text-body-2 mb-4 text-ui-kit-text">
          Предлагать Пользователям размещать информацию на других сайтах и/или приложениях,
          предоставляющих сервисы (услуги) аналогичные Сайту и/или Приложению.
        </p>
      </li>
      <li>
        <p class="text-body-2 mb-4 text-ui-kit-text">
          Размещать данные, полученные с Сайта и/или Приложения, на ином сайте (сайтах) и/или
          приложениях, представляющих сервисы (услуги), аналогичные Сайту и/или Приложению.
        </p>
      </li>
      <li>
        <p class="text-body-2 mb-4 text-ui-kit-text">
          Распространять любую контактную информацию Пользователей или иных физических и
          юридических лиц, включая, но не ограничиваясь, номер телефона, адрес электронной почты,
          доменное имя сайта.
        </p>
      </li>
    </ul>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      2. Пользователь,
      предоставляя Администрации информацию/материалы к размещению на
      Сайте и/или в Приложении, либо размещая информацию/материалы на сайте
      самостоятельно, в случае наличия такой технической возможности, гарантирует соблюдение
      им требований действующего законодательства Республики Беларусь, включая Закон
      Республики Беларусь от 10 мая 2007 года № 225-З «О рекламе». В случае привлечения
      Администрации Сайта к ответственности за нарушение действующего законодательства
      Республики Беларусь (включая Закон Республики Беларусь от 10 мая 2007 года № 225-З «О
      рекламе») в связи с размещением Пользователем информации/материалов на Сайте и/или в
      Приложении или размещением Администрацией информации/материалов на Сайте и/или в
      Приложении, предоставленных ему Пользователем, Пользователь возмещает Администрации
      Сайта все возможные понесенные им расходы, включая, но не ограничивая: штрафы,
      судебные расходы и прочее, в течение 10 календарных дней с момента предъявления
      соответствующего требования Администрацией Сайта в адрес Пользователя.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3. Пользователь
      принимает положение о том, что все материалы и сервисы Сайта и/или
      Приложения или любая их часть могут сопровождаться рекламой.
    </p>
    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      Обязательства Администрации
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1. В случае наличия сомнений относительно правомерности использования Сайта и/или
      Приложения Пользователем, Администрация вправе в любое время и без предварительного
      уведомления Пользователя по своему усмотрению удалить, блокировать или принудительно
      изменить Учетную информацию таких Пользователей.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      2. В случае наличия сведений об использовании Учетной информации Пользователя другими
      Пользователями или какими-либо третьими лицами, Администрация Сайта вправе в любое
      время и без предварительного уведомления Пользователя по своему усмотрению удалить,
      блокировать или принудительно изменить учетную информацию такого Пользователя.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3. Администрация вправе в любое время, без какого-либо предварительного уведомления или
      компенсации техническим образом блокировать использование учетной информации любому
      Пользователю, если он нарушает Пользовательское соглашение.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      4. В случае расторжения (прекращения) договора с Пользователем, прекращения оказания
      услуг, предоставляемых на основе заключенного договора, или отсутствия какого-либо
      заключенного договора с Пользователем Администрация Сайта вправе в любое время без
      предупреждения и согласования с Пользователем, а также без какой-либо компенсации и
      объяснения причин удалить регистрацию и всю его Учетную информацию на Сайте.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      5. Администрация не несет ответственности за неисполнение или ненадлежащее исполнение
      своих обязательств, а также возможный ущерб, возникший в результате:
      (а) неправомерных действий пользователей сети Интернет, направленных на нарушения
      информационной безопасности или нормального функционирования Сайта и/или
      Приложения;(б) сбоев в работе Сайта и/или Приложения, вызванных в том числе, ошибками в коде,
      компьютерными вирусами и иными посторонними фрагментами кода в программном
      обеспечении Сайта и/или Приложения;
      (в) отсутствия (невозможности установления, прекращения и пр.) Интернет-соединений
      между сервером Пользователя и сервером Сайта и/или Приложения;
      (г) проведения государственными и муниципальными органами, а также иными
      организациями мероприятий в рамках Системы оперативно-розыскных мероприятий
      (СОРМ);
      (д) установления государственного регулирования (или регулирования иными
      организациями) хозяйственной деятельности коммерческих организаций в сети Интернет и/
      или установления указанными субъектами разовых ограничений, затрудняющих или
      делающих невозможным исполнение своих обязательств Администрацией;
      (е) других случаев, связанных с действиями (бездействием) пользователей Интернета и/или
      других субъектов, направленными на ухудшение общей ситуации с использованием сети
      Интернет и/или компьютерного оборудования.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      6. Настоящим Пользователь выражает свое согласие на получение от Администрации (в любое
      время и без предварительного предупреждения Администрации) по адресу электронной
      почты и/или на телефонный номер, указанные Пользователем при регистрации на Сайте
      и/или Приложении, информационных сообщений, а также иную информацию, включая
      рекламу.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      7. Администрация вправе в любое время, в том числе без какого-либо предварительного
      уведомления Пользователя, приостанавливать работу Сайта и/или Приложения для
      проведения профилактических работ, по возможности в ночное время или выходные дни.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      8. Пользователь согласен с тем, что Администрация оставляет за собой право прекратить
      работу Личного кабинета Пользователя на любом из сервисов Сайта и/или Приложения и
      удалить любой контент по любой причине, в том числе при нарушении ПС.
    </p>
    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      Использование материалов Пользователя
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1. Пользователь соглашается, что любые опубликованные в общем доступе на Сайте и/или
      Приложении материалы будут общедоступны сколь угодно долго, смогут индексироваться
      различными поисковыми системами, могут быть использованы всеми другими
      Пользователями, а равно и Сайтом, без выплаты пользователю каких-либо вознаграждений и
      без дополнительного разрешения. Также Пользователь согласен с тем, что удаление
      материалов после их публикации запрещено.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      2. Администрация
      обеспечивает соблюдение конфиденциальности полученных от
      Пользователей сведений, содержащих персональные данные, в соответствии с требованиями
      Закона Республики Беларусь № 99-3 «О защите персональных данных». Сбор, обработка,
      хранение и использование указанных сведений производится Администрацией Сайта с
      согласия Пользователя на сбор и обработку персональных данных, на основании Политики
      обработки персональных данных пользователей в полном соответствии с требованиями
      законодательства Республики Беларусь.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3. Сайт
      вправе раскрывать Персональные данные Пользователя по запросам
      правоохранительных органов, решению суда и в прочих случаях, предусмотренных
      законодательством Республики Беларусь.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      4. Зарегистрированный Пользователь имеет право в любое время удалить свои персональные
      данные. После удаления Пользователем своих персональных данных опубликованные им
      материалы определяются как анонимные.
    </p>
    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      Финансовые отношения
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1. В связи с тем, что по настоящему ПС Пользователю не предоставляется никаких платных
      услуг, на отношения между Администрацией и Пользователями не распространяется Закон
      Республики Беларусь № 90-3 «О защите прав потребителей».
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      2. Администрация оставляет за собой право предоставлять Пользователям платные сервисы
      Сайта и/или Приложения. Платные сервисы Сайта и/или Приложения предоставляются по
      волеизъявлению Пользователя. Платные сервисы Сайта и/или Приложения и Услуги,
      оказываемые Администрацией или третьими лицами, регулируются отдельными договорами,
      в случае их заключения между Администрацией или третьими лицами и Пользователем.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3. Администрация
      не является представителем врачей, лечебных учреждений, а также
      физических лиц, обращающихся к ним за медицинской помощью, поэтому не может отвечать
      ни за какие финансовые обязательства, возникающие между теми и другими. Любые
      договоренности между вышеуказанными лицами, использующими Сайт и/или Приложение,
      являются двусторонними, и Администрация не имеет к ним отношения.
    </p>
    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      Прекращение регистрации
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      Пользователь согласен с тем, что Администрация оставляет за собой право прекратить
      действие Вашего логина и пароля на любом из сервисов Сайта и/или Приложения и удалить
      любой контент по любой причине, в том числе при нарушении ПС или законодательства
      Республики Беларусь.
    </p>
    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      Ограниченная гарантия на использование Сайта и/или Приложения
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      1. Администрация не гарантирует, что программное обеспечение Сайта и/или Приложения не
      содержит ошибок и/или компьютерных вирусов, или посторонних фрагментов кода.
      Пользователю предоставляется возможность пользоваться программным обеспечением
      Сайта и/или Приложения «как оно есть», без каких-либо гарантий со стороны
      Администрации.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      2. Администрация и ее работники ни при каких обстоятельствах не оказывают Пользователю
      медицинских услуг, платных или бесплатных, в том числе в форме консультирования, не
      дают советов о диагностике и лечении заболеваний, а также приеме лекарственных средств.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      3. Информация о медицинских услугах, болезнях, специализации врачей носит справочный
      характер. Администрация не гарантирует ее достоверность и соответствие современным
      научным достижениям. Администрация настоятельно рекомендует обращаться за
      квалифицированной медицинской помощью непосредственно к врачам требуемой специализации,
      в том числе к тем, профили которых представлены на Сайте и/или в
      Приложении.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      4. Поскольку идентификация пользователей и посетителей Сайта и/или Приложения затруднена
      по техническим причинам, Администрация не отвечает за то, что зарегистрированные
      пользователи являются действительно теми лицами, за которых себя выдают, и не несет
      ответственности за возможный ущерб, причиненный пользователям Сайта и/или
      Приложения или другим лицам по этой причине.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      5. Если использование Пользователем Сайта и/или Приложения повлекло за собой утрату
      данных или порчу оборудования, Администрация не несет за это ответственности.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      6. Пользователь соглашается с тем, что Администрация не несет никакой ответственности за
      возможные перебои в предоставлении сервисов Сайта и/или Приложения, а также за
      сохранность материалов Пользователя.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      7. Администрация не несет ответственности за любые прямые или непрямые убытки,
      произошедшие из-за использования либо невозможности использования Сайта и/или
      Приложения, несанкционированного доступа к учетной информации Пользователя.
    </p>
    <p class="text-body-2 mb-4 text-ui-kit-text">
      8. Администрация не несет ответственности за использование третьими лицами (правомерное
      и неправомерное) материалов, размещенных Пользователем на Сервисах Сайта и/или
      Приложения, включая их копирование, тиражирование и распространение, осуществляемое
      как в рамках Сайта и/или Приложения, так и иными возможными способами.
    </p>
    <p class="text-h6 mt-6 mb-4 text-ui-kit-text">
      Заключительные положения
    </p>
    <p class="text-body-2 text-ui-kit-text mb-0">
      Настоящее ПС действует в течение всего периода использования Сайта и/или Приложения
      Пользователем.
    </p>
  </div>
</template>

<style scoped lang="scss">
.custom-list {
  list-style-type: "- ";
}
</style>
